import { FormGroup, FormControl } from '@angular/forms';
/*
  Custom validators to use everywhere.
*/// SINGLE FIELD VALIDATORS
export function emailValidator(control: FormControl): { [key: string]: any } {    
    let emailRegexp = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/;
    if (control.value && !emailRegexp.test(control.value)) {
        return { invalidEmail: true };
    }
};

export function notNullGuid(control: FormControl): { [key: string]: any } {
    if (control.value == '' || control.value == '00000000-0000-0000-0000-000000000000') {
        return { required: true };
    }
}

// FORM GROUP VALIDATORS
export function areEqual(ctrl1: string, ctrl2: string) {
    return (group: FormGroup): { [key: string]: any } => {
        let str = group.controls[ctrl1];
        let strConfirm = group.controls[ctrl2];
        if (str.value !== strConfirm.value) {
            return {
                areNotEqual: true
            };
        }
    };
}


// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./~/angular2-template-loader!./~/source-map-loader!./~/tslint-loader!./angularApp/app/validators/validators.ts